import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import useAuthRequest from '../services/requests.service';

// Hook pour récupérer les pages de l'utilisateur (sans filtrage côté serveur)
export const useUserPages = () => {
  const request = useAuthRequest();
  
  return useQuery({
    queryKey: ['userPages'],
    queryFn: () => request.getDataAPI('/pagesByUserId'),
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

// Hook pour créer une page
export const useCreatePage = () => {
  const request = useAuthRequest();
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (pageData) => request.postDataAPI('/page', pageData),
    onSuccess: () => {
      // Invalider toutes les requêtes de pages
      queryClient.invalidateQueries(['userPages']);
    },
  });
};

// Hook pour mettre à jour une page
export const useUpdatePage = () => {
  const request = useAuthRequest();
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }) => request.patchDataAPI(`/page/${id}`, data),
    onSuccess: (data, { id }) => {
      // Invalider les requêtes spécifiques
      queryClient.invalidateQueries(['userPages']);
      queryClient.invalidateQueries(['page', id]);
    },
  });
};

// Hook pour supprimer une page
export const useDeletePage = () => {
  const request = useAuthRequest();
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id) => request.deleteDataAPI(`/page/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries(['userPages']);
    },
  });
};

// Hook pour récupérer une page spécifique
export const usePage = (id) => {
  const request = useAuthRequest();
  
  return useQuery({
    queryKey: ['page', id],
    queryFn: () => request.getDataAPI(`/page/${id}`),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};